(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
if (firstSectionImage) {
firstSectionImage.setAttribute('loading', 'eager');
firstSectionImage.setAttribute('fetchpriority', 'high');
}

  } catch(e) { console.error(e); }
})();
})();
